import { render, staticRenderFns } from "./Factura.vue?vue&type=template&id=2654537e&"
import script from "./Factura.vue?vue&type=script&lang=js&"
export * from "./Factura.vue?vue&type=script&lang=js&"
import style0 from "./Factura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports